import { compose, filter, get, head, last, map, omit, toPairs } from 'lodash/fp';
import api from '../../../../../../api';
import { getTimelineMode } from '../Model';
const getDisabledDates = compose(map(head), filter(last), toPairs, get('disabledDates'));
export function rectifyTimeline(model) {
    const timelineMode = getTimelineMode(model);
    const baseTimeline =
        timelineMode === 'shared'
            ? {
                  ...model.timeline,
                  editableByManagerFrom: model.timeline?.editableByOwnerFrom,
                  editableByManagerUntil: model.timeline?.editableByOwnerUntil,
                  statusEditableByManagerUntil: model.timeline?.statusEditableByOwnerUntil,
              }
            : model.timeline;

    const keysToRemove = getDisabledDates(model);

    if (timelineMode === 'shared') {
        if (keysToRemove.includes('editableByOwnerFrom')) {
            keysToRemove.push('editableByManagerFrom');
        }
        if (keysToRemove.includes('editableByOwnerUntil')) {
            keysToRemove.push('editableByManagerUntil');
        }
        if (keysToRemove.includes('statusEditableByOwnerUntil')) {
            keysToRemove.push('statusEditableByManagerUntil');
        }
    }

    return omit(keysToRemove, baseTimeline);
}

export function createObjectiveCycle(model, inform, staffSelection) {
    return api.objectiveCycles.create(rectifyModel(model, staffSelection), inform);
}

export async function updateObjectiveCycle(model) {
    const STAFF_SELECTION = null;
    const updatedObjectiveCycle = await api.objectiveCycles.update(rectifyModel(model, STAFF_SELECTION));
    // Objective list views cache data that embeds cycle info, so we need to invalidate those caches too.
    api._objectives.notifyUpdate();
    return updatedObjectiveCycle;
}

export function rectifyModel(model, staffSelection) {
    const { options, allowedUsers } = model;

    return {
        ...model,
        timeline: rectifyTimeline(model),
        allowedUsers: rectifyAllowedUsers(allowedUsers, staffSelection),
        options: rectifyOptions(options),
    };
}

function rectifyAllowedUsers(allowedUsers, staffSelection) {
    return staffSelection === 'STAFF_SELECTION_ALL_STAFF' ? null : allowedUsers;
}

function rectifyOptions(options) {
    const { categories, ratings } = options;
    return {
        ...options,
        categories: rectifyCustomizableItem(categories),
        ratings: rectifyCustomizableItem(ratings),
    };
}

function rectifyCustomizableItem(item) {
    const { enabled } = item;
    if (enabled) {
        return item;
    } else {
        return { enabled, values: null };
    }
}
